import {
  komaEndTime,
  komaNumberTimeRange,
  komaNumberToTime,
} from '~/models/komaToTime'

/** 連続コマの 1 区間 (両端含む、1-origin) + 時刻帯。 */
export type KomaRange = {
  start: number
  end: number
  /** 区間の時刻帯 "HH:MM〜HH:MM" (コマ 48 を含む区間は "24:00" で折り返さない)。 */
  timeLabel: string
}

const timeLabelFor = (start: number, end: number): string =>
  // 単一コマ区間は既存の komaNumberTimeRange をそのまま使う (部分再実装しない)。
  start === end
    ? komaNumberTimeRange(start, '〜')
    : `${komaNumberToTime(start)}〜${komaEndTime(komaNumberToTime(end))}`

/**
 * 昇順・重複なしのコマ番号列を連続区間に畳む。
 * 例: [1, 2, 3, 46, 47, 48] → [{start:1,end:3,...}, {start:46,end:48,...}]。
 * 空配列 → 空配列。
 */
export function groupContiguousKomaRanges(
  komas: readonly number[],
): KomaRange[] {
  if (komas.length === 0) {
    return []
  }
  const ranges: KomaRange[] = []
  const pushRange = (start: number, end: number): void => {
    ranges.push({ start, end, timeLabel: timeLabelFor(start, end) })
  }
  let start = komas[0]
  let prev = komas[0]
  for (let i = 1; i < komas.length; i++) {
    const koma = komas[i]
    if (koma === prev + 1) {
      prev = koma
      continue
    }
    pushRange(start, prev)
    start = koma
    prev = koma
  }
  pushRange(start, prev)
  return ranges
}
